import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { RequestResponseHeaderEnum } from '@splitsecondconnect/ultramarine-shared';
import { Observable } from 'rxjs';
import { environment } from '@marineform/environment';
import { WebsocketService } from '../services/websocket.service';
import { WS_EXCLUDE_SUBSCRIPTION_ID } from '../tokens/ws-exclude-subscription-id.token';

const WEBSOCKET_SOCKET_ID_METHODS = ['POST', 'PUT', 'PATCH', 'DELETE'];

/**
 * Attaches WebSocket correlation headers on mutating core-api requests.
 *
 * Socket id lets core-api echo opinions to the originating client. An
 * optional exclude-subscription id on the request context suppresses the
 * caller's own list opinion for that subscription.
 */
export const WebsocketInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  const shouldAttachSocketId =
    req.url.startsWith(environment.ultramarineBaseUrl) &&
    WEBSOCKET_SOCKET_ID_METHODS.includes(req.method);

  if (!shouldAttachSocketId) {
    return next(req);
  }

  const socketId = inject(WebsocketService).ioSocket.id;
  const excludeSubscriptionId = req.context.get(WS_EXCLUDE_SUBSCRIPTION_ID);

  let headers = req.headers;
  if (socketId) {
    headers = headers.set(
      RequestResponseHeaderEnum.WEBSOCKET_SOCKET_ID,
      socketId,
    );
  }
  if (excludeSubscriptionId) {
    headers = headers.set(
      RequestResponseHeaderEnum.WEBSOCKET_EXCLUDE_SUBSCRIPTION_ID,
      excludeSubscriptionId,
    );
  }

  return next(req.clone({ headers }));
};
